import styled from "styled-components";
import { Link } from "react-router-dom";

export const TopMenuContainer = styled.div`
  width: 100%;
  height: 60px;
  background: #0d0d0d;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  border-bottom: 1px solid #2a2a2a;
  justify-content: space-between;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  padding-left: 20px;
  padding-right: 20px;
  box-sizing: border-box;
  padding-top: 10px;
  padding-bottom: 10px;
`;

export const TopMenuMain = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  min-width: 0;
`;

export const TopMenuLogoLink = styled.a`
  display: flex;
  align-items: center;
  text-decoration: none;
  flex-shrink: 0;
`;

export const TopMenuAccount = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

export const MenuIconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #fff;
  cursor: pointer;
  flex-shrink: 0;

  &:hover {
    background: rgba(255, 255, 255, 0.06);
  }
`;

/** Overlay: acima do conteúdo e da top bar (z-index 1000); backdrop 1100, painel 1101 */
export const DrawerBackdrop = styled.button`
  position: fixed;
  inset: 0;
  z-index: 1100;
  margin: 0;
  padding: 0;
  border: none;
  background: rgba(0, 0, 0, 0.65);
  cursor: pointer;
`;

export const DrawerPanel = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 1101;
  width: min(300px, 88vw);
  max-width: 300px;
  display: flex;
  flex-direction: column;
  background: #0a0a0a;
  border-right: 1px solid #2a2a2a;
  box-shadow: 8px 0 32px rgba(0, 0, 0, 0.45);
  animation: navDrawerIn 0.2s ease-out;

  @keyframes navDrawerIn {
    from {
      transform: translateX(-100%);
    }
    to {
      transform: translateX(0);
    }
  }
`;

export const DrawerHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  padding: 16px 16px 12px;
  flex-shrink: 0;
`;

export const DrawerBrandIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #00ffc2;
`;

export const DrawerBrandText = styled.span`
  flex: 1;
  font-weight: 700;
  font-size: 1.125rem;
  color: #fff;
  letter-spacing: -0.02em;
`;

export const DrawerCloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #fff;
  cursor: pointer;

  &:hover {
    background: rgba(255, 255, 255, 0.06);
  }
`;

export const DrawerDivider = styled.div`
  height: 1px;
  background: #2a2a2a;
  margin: 0 16px;
  flex-shrink: 0;
`;

export const DrawerSectionLabel = styled.div`
  font-size: 0.6875rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #6e6e6e;
  padding: 16px 16px 8px;
`;

export const DrawerNavBlock = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow-y: auto;
`;

export const DrawerNavLink = styled(Link)<{ $active?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  margin: 4px 12px;
  padding: 12px 12px;
  border-radius: 8px;
  text-decoration: none;
  font-size: 0.9375rem;
  font-weight: 500;
  color: ${({ $active }) => ($active ? "#00ffc2" : "#8e8e8e")};
  background: ${({ $active }) =>
        $active ? "rgba(0, 255, 194, 0.12)" : "transparent"};
  transition:
    background 0.15s ease,
    color 0.15s ease;

  svg {
    flex-shrink: 0;
    color: inherit;
  }

  &:hover {
    color: ${({ $active }) => ($active ? "#00ffc2" : "#c4c4c4")};
    background: ${({ $active }) =>
        $active ? "rgba(0, 255, 194, 0.16)" : "rgba(255, 255, 255, 0.04)"};
  }
`;

export const DrawerFooter = styled.div`
  flex-shrink: 0;
  padding-bottom: 16px;
`;

export const DrawerSettingsButton = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  width: calc(100% - 24px);
  margin: 4px 12px;
  padding: 12px 12px;
  border: none;
  border-radius: 8px;
  background: transparent;
  font-size: 0.9375rem;
  font-weight: 500;
  color: #8e8e8e;
  cursor: pointer;
  text-align: left;

  svg {
    flex-shrink: 0;
  }

  &:hover {
    color: #c4c4c4;
    background: rgba(255, 255, 255, 0.04);
  }
`;

export const DrawerFooterInfos = styled.div`
  display: flex;
  flex-direction: row;
  align-items: start;  
  width: 100%;  
  font-size: 11px;
  font-weight: 400;
  color: #8e8e8e;  
  padding-left: 10px;
  padding-right: 10px;  
`;
